import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private requestCount = 0;
  public forceLoading = false;
  private _loadingMessage = new BehaviorSubject<string>('');

  constructor(private _spinnerService: NgxSpinnerService) {}

  get loadingMessage$() {
    return this._loadingMessage.asObservable();
  }

  setLoadingMessage(message: string) {
    this._loadingMessage.next(message);
  }

  show() {
    this.requestCount++;
    this._spinnerService.show(undefined, {
      type: 'ball-clip-rotate',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      size: 'medium',
    });
  }

  hide() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this._spinnerService.hide();
    }
  }
}
